export enum ContactTypeEnum {
  NO_TYPE,
  CONSULT,
  PRESCRIPTION,
  CONSULT_THIRD_PARTY,
  DOCUMENT_PROCESSING,
  TELEPHONE_CONSULT,
  CARE_HOME,
  IMPORT,
  ADVICE,
  HOSPITAL_VISIT,
  EMAIL,
  DELIBERATION,
  FILE_UPDATE,
  HOUSEVISIT_DOUBLE,
  HOUSEVISIT_TRIPLE,
  HOUSEVISIT,
}
